import styles from "./QnaBoard.module.css";
import ListBoard from "Page/common/ListBoard";

export default function QnaBoard() {
  return (
    <div className={styles.QnaBoard}>
      <ListBoard api="support/qna" title="Q&A" postTitle="문의하기" />
    </div>
  );
}
